/* eslint-disable no-unused-vars */
const loadGoogleMapsApi = require('load-google-maps-api')

const marker = {
	url: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="110" height="110" viewBox="0 0 110 110"%3E%3Cdefs%3E%3Cfilter id="a" width="228.3%25" height="228.3%25" x="-64.2%25" y="-60.8%25" filterUnits="objectBoundingBox"%3E%3CfeOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/%3E%3CfeGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="12.5"/%3E%3CfeColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.101960784 0"/%3E%3C/filter%3E%3Crect id="b" width="60" height="60" x="0" y="0" rx="2"/%3E%3C/defs%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg transform="translate(25 23)"%3E%3Cuse fill="%23000" filter="url(%23a)" xlink:href="%23b"/%3E%3Cuse fill="%23FFF" xlink:href="%23b"/%3E%3C/g%3E%3Cg fill="%23ED7723"%3E%3Cpath d="M35 49.8630112h5.75809673V44H35zM51.7508268 44L67.475088 62.1220346h7.3081257L59.0589525 44zM43.37541342 44L58.9074177 62.1220346h6.9769193L50.3523327 44zM51.7508268 62.1220346h5.7580968l-5.7580968-6.9290132zM42.32848674 62.1220346h5.75809676V50.88072571L42.32848674 44z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E',
	scale: 1.5
}

window.addEventListener('load', () => {
	const mapSelector = document.querySelector('#maps')
	if (mapSelector) {
		loadGoogleMapsApi({
			key: ''
		}).then(function (googleMaps) {
			const map = new googleMaps.Map(mapSelector, {
				center: {
					lat: 51.427070,
					lng: 4.350630
				},
				zoom: 15,
				disableDefaultUI: true
			})
			new googleMaps.Marker({
				position: map.getCenter(),
				icon: marker,
				map: map
			});
		}).catch(function (error) {
			console.error(error)
		})
	}
});



// WEBPACK FOOTER //
// ./js/modules/content/maps.js